import { TESLA_HERO_BASE64 } from "./vilmer-tesla-hero";
export const DEMO_BRAND = {
    name: "VilMer",
    logoUrl: "https://cdn.prod.website-files.com/5dc1b29aff88ca7f1b359d0a/630f0764c8d2fb2cdb3b36c2_VilMer-logo.svg",
    color: "#500E46",
};
const TILE_PALETTES = [
    ["#E8B44A", "#B4531F"],
    ["#7FB069", "#25603A"],
    ["#C97BA6", "#6B2D5B"],
    ["#6FA8CF", "#274A6D"],
    ["#E08A6B", "#9C3B2E"],
];
const TILE_ART = {
    0: `<path d="M80 88c-18-12-30-22-30-35a15 15 0 0 1 30-6 15 15 0 0 1 30 6c0 13-12 23-30 35z"/>`,
    9: `<path d="M80 88c-18-12-30-22-30-35a15 15 0 0 1 30-6 15 15 0 0 1 30 6c0 13-12 23-30 35z"/>`,
    1: `<path d="M44 40c12-6 24-6 36 0v46c-12-6-24-6-36 0zm72 0c-12-6-24-6-36 0v46c12-6 24-6 36 0z"/>`,
    7: `<path d="M44 40c12-6 24-6 36 0v46c-12-6-24-6-36 0zm72 0c-12-6-24-6-36 0v46c12-6 24-6 36 0z"/>`,
    2: `<circle cx="64" cy="46" r="13"/><circle cx="97" cy="50" r="10"/><path d="M40 88c0-14 11-24 24-24s24 10 24 24zm52 0c0-11 6-19 16-19s14 8 14 19z"/>`,
    8: `<circle cx="64" cy="46" r="13"/><circle cx="97" cy="50" r="10"/><path d="M40 88c0-14 11-24 24-24s24 10 24 24zm52 0c0-11 6-19 16-19s14 8 14 19z"/>`,
    3: `<path d="M80 30c10 14 18 22 18 33a18 18 0 1 1-36 0c0-11 8-19 18-33z"/><rect x="72" y="84" width="16" height="8" rx="3"/>`,
    4: `<path d="M108 34c4 34-14 56-44 56-6 0-12-1-16-3 20-4 32-16 38-30-10 8-22 12-34 10 16-6 26-18 30-30 10 0 20-1 26-3z"/>`,
    5: `<path d="M96 30v40a14 14 0 1 1-8-12V44l-26 7v31a14 14 0 1 1-8-12V44z"/>`,
    6: `<path d="M50 46h48v22a24 24 0 0 1-48 0zm48 4h8a10 10 0 0 1 0 20h-8zM46 92h56v6H46z"/>`,
};
export function sampleTile(seed) {
    var _a;
    const [from, to] = TILE_PALETTES[seed % TILE_PALETTES.length];
    const angle = (seed * 37) % 180;
    const art = (_a = TILE_ART[seed % 10]) !== null && _a !== void 0 ? _a : TILE_ART[2];
    const W = 400;
    const H = 160;
    const motif = (x, y, s, o) => `<g transform="translate(${x} ${y}) scale(${s})" fill="#fff" fill-opacity="${o}">${art}</g>`;
    return (`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}">` +
        `<defs><linearGradient id="g" gradientTransform="rotate(${angle} 0.5 0.5)">` +
        `<stop offset="0%" stop-color="${from}"/><stop offset="100%" stop-color="${to}"/>` +
        `</linearGradient></defs>` +
        `<rect width="${W}" height="${H}" fill="url(#g)"/>` +
        motif(120, 20, 0.85, 0.66) +
        motif(-10, 34, 0.6, 0.3) +
        motif(268, 30, 0.66, 0.34) +
        `</svg>`);
}
export function sampleTileDataUri(seed) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(sampleTile(seed))}`;
}
export const SAMPLE_IMAGE_PATH = "/api/vilmer/v1/sample-image";
function hash(s) {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}
const TEMPLATES = [
    {
        title: "Morgongymnastik",
        location: "Samlingssalen",
        category: "rorelse",
        description: "Lugna rörelser sittande på stol. Vi mjukar upp axlar, nacke och ben. Alla kan vara med, i sin egen takt.",
        hour: 9,
        minutes: 45,
    },
    {
        title: "Högtläsning",
        location: "Dagligrummet",
        category: "kultur",
        description: "Vi fortsätter läsa ur Margit Sandemos böcker. Kaffe och kaka efteråt för den som vill stanna kvar.",
        hour: 11,
        minutes: 60,
    },
    {
        title: "Bingo",
        location: "Matsalen",
        category: "social",
        description: "Klassisk bingo med små priser. Ta med en granne - det brukar bli fullt hus.",
        hour: 14,
        minutes: 75,
    },
    {
        title: "Andakt",
        location: "Andaktsrummet",
        category: "andlighet",
        description: "Stilla stund med psalmsång tillsammans med diakon Karin. Öppet för alla, oavsett tro.",
        hour: 15,
        minutes: 45,
    },
    {
        title: "Promenad i trädgården",
        location: "Innergården",
        category: "utomhus",
        description: "Vi går en runda tillsammans. Personal följer med, rullstol går bra. Ta med jacka.",
        hour: 13,
        minutes: 40,
    },
    {
        title: "Musikcafé",
        location: "Dagligrummet",
        category: "musik",
        description: "Levande dragspelsmusik och allsång med Bengt. Sånghäften finns att låna.",
        hour: 15,
        minutes: 60,
    },
    {
        title: "Bakning",
        location: "Köket",
        category: "skapande",
        description: "Vi bakar kanelbullar tillsammans. Det doftar i hela huset efteråt.",
        hour: 10,
        minutes: 90,
    },
    {
        title: "Filmvisning",
        location: "Samlingssalen",
        category: "kultur",
        description: "Vi visar Sällskapsresan på storbild. Popcorn och saft serveras i pausen.",
        hour: 18,
        minutes: 105,
    },
    {
        title: "Frågesport",
        location: "Dagligrummet",
        category: "social",
        description: "Lagtävling med frågor om musik, film och Sverige förr i tiden. Ingen behöver kunna svaren.",
        hour: 14,
        minutes: 50,
    },
    {
        title: "Fotvård",
        location: "Behandlingsrummet",
        category: "omsorg",
        description: "Fotvårdare Anneli är på plats. Tider bokas i receptionen, drop-in i mån av plats.",
        hour: 10,
        minutes: 30,
    },
];
function pad(n) {
    return String(Math.floor(Math.abs(n))).padStart(2, "0");
}
export const DEMO_TIMEZONE = "Europe/Stockholm";
function offsetMinutes(at, timeZone) {
    var _a;
    const name = (_a = new Intl.DateTimeFormat("en-US", {
        timeZone,
        timeZoneName: "longOffset",
    })
        .formatToParts(at)
        .find((p) => p.type === "timeZoneName")) === null || _a === void 0 ? void 0 : _a.value;
    const m = /GMT([+-])(\d{2}):(\d{2})/.exec(name !== null && name !== void 0 ? name : "");
    if (!m)
        return 0;
    const sign = m[1] === "-" ? -1 : 1;
    return sign * (Number(m[2]) * 60 + Number(m[3]));
}
function localInstant(date, hour, minute) {
    const [y, m, d] = date.split("-").map(Number);
    const at = new Date(y !== null && y !== void 0 ? y : 1970, (m !== null && m !== void 0 ? m : 1) - 1, d !== null && d !== void 0 ? d : 1, hour, minute, 0, 0);
    const off = offsetMinutes(at, DEMO_TIMEZONE);
    const sign = off >= 0 ? "+" : "-";
    return (`${y}-${pad(m !== null && m !== void 0 ? m : 1)}-${pad(d !== null && d !== void 0 ? d : 1)}` +
        `T${pad(hour)}:${pad(minute)}:00` +
        `${sign}${pad(off / 60)}:${pad(off % 60)}`);
}
function eachDate(from, to) {
    const out = [];
    const [fy, fm, fd] = from.split("-").map(Number);
    const [ty, tm, td] = to.split("-").map(Number);
    const cur = new Date(fy !== null && fy !== void 0 ? fy : 1970, (fm !== null && fm !== void 0 ? fm : 1) - 1, fd !== null && fd !== void 0 ? fd : 1);
    const end = new Date(ty !== null && ty !== void 0 ? ty : 1970, (tm !== null && tm !== void 0 ? tm : 1) - 1, td !== null && td !== void 0 ? td : 1);
    for (let i = 0; i <= 60 && cur <= end; i++) {
        out.push(`${cur.getFullYear()}-${pad(cur.getMonth() + 1)}-${pad(cur.getDate())}`);
        cur.setDate(cur.getDate() + 1);
    }
    return out;
}
const FEATURED_DATE = "2026-10-05";
const TESLA_IMAGE_SEED = "tesla";
export const TESLA_HERO_DATA_URI = `data:image/jpeg;base64,${TESLA_HERO_BASE64}`;
function featuredActivity(imageBase) {
    return {
        id: `fx-film-tesla-${FEATURED_DATE}`,
        start: localInstant(FEATURED_DATE, 18, 0),
        end: localInstant(FEATURED_DATE, 20, 0),
        title: "Filmvisning - Tesla",
        location: "Gemensamhetsutrymmet",
        category: "kultur",
        description: "Vi träffas i gemensamhetsutrymmet och tittar på filmen Tesla. Den genialiske uppfinnaren Nikola Tesla (Ethan Hawke) kämpar i uppförsbacke för att göra verklighet av sitt revolutionerande elektriska system.",
        imageUrl: imageBase
            ? `${imageBase}/${TESLA_IMAGE_SEED}`
            : TESLA_HERO_DATA_URI,
        action: { label: "Spela" },
        banner: {
            title: "Tesla",
            meta: "2020 | 11 | Drama",
            text: "Den genialiske uppfinnaren Nikola Tesla (Ethan Hawke) kämpar i uppförsbacke för att göra verklighet av sitt revolutionerande elektriska system.",
        },
    };
}
export const TESLA_IMAGE_SEED_PARAM = TESLA_IMAGE_SEED;
export function demoActivities(token, from, to, opts = {}) {
    const seed = hash(token);
    const out = [];
    for (const date of eachDate(from, to)) {
        const daySeed = hash(`${token}:${date}`);
        const weekday = new Date(Number(date.slice(0, 4)), Number(date.slice(5, 7)) - 1, Number(date.slice(8, 10))).getDay();
        const count = weekday === 0 ? 1 : 2 + (daySeed % 3);
        const picked = new Set();
        for (let i = 0; i < count; i++) {
            const idx = (daySeed + i * 7 + seed) % TEMPLATES.length;
            if (picked.has(idx))
                continue;
            picked.add(idx);
            const t = TEMPLATES[idx];
            if (date === FEATURED_DATE && t.title === "Filmvisning")
                continue;
            out.push({
                id: `fx-${date}-${idx}`,
                start: localInstant(date, t.hour, 0),
                end: localInstant(date, t.hour + Math.floor(t.minutes / 60), t.minutes % 60),
                title: t.title,
                location: t.location,
                category: t.category,
                description: t.description,
                ...(idx % 3 === 2
                    ? {}
                    : {
                        imageUrl: opts.imageBase
                            ? `${opts.imageBase}/${idx}`
                            : sampleTileDataUri(idx),
                    }),
                ...(daySeed % 11 === 0 && i === 0 ? { cancelled: true } : {}),
            });
        }
    }
    if (from <= FEATURED_DATE && FEATURED_DATE <= to) {
        out.push(featuredActivity(opts.imageBase));
    }
    out.sort((a, b) => a.start.localeCompare(b.start));
    return out;
}
